// extracted by mini-css-extract-plugin
export default {"form-control-label":"Label_form-control-label__QcqfU","dark-label":"Label_dark-label__+EUvb","light-label":"Label_light-label__naFAp"};